(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.NulelaCartDrawer = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  var sectionNames = 'cart-drawer,cart-icon-bubble';
  var reminderEnd = null;
  var reminderKey = 'nulela-cart-reminder-v1';

  function reminderDeadline(saved, now) {
    return Number(saved) > 0 && Number.isFinite(Number(saved)) ? Number(saved) : now + 300000;
  }

  function reminderTime(deadline, now) {
    var seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
    return String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
  }

  function tickReminder() {
    var banner = document.querySelector('[data-nulela-cart-reminder]');
    if (!banner) return;
    var drawer = banner.closest('cart-drawer');
    if (drawer && drawer.classList.contains('is-empty')) return;
    if (reminderEnd === null) {
      var saved = null;
      try { saved = window.sessionStorage.getItem(reminderKey); } catch (error) {}
      reminderEnd = reminderDeadline(saved, Date.now());
      try { window.sessionStorage.setItem(reminderKey, String(reminderEnd)); } catch (error) {}
    }
    var clock = banner.querySelector('[data-nulela-cart-clock]');
    if (clock) clock.textContent = reminderTime(reminderEnd, Date.now());
    var expired = Date.now() >= reminderEnd;
    banner.classList.toggle('is-expired', expired);
    var label = banner.querySelector('[data-nulela-cart-timer-label]');
    if (label) label.textContent = banner.getAttribute(expired ? 'data-expired-label' : 'data-active-label');
  }

  function buildProtectionRequest(options) {
    if (options.enabled) {
      return {
        endpoint: '/cart/add.js',
        body: { items: [{ id: String(options.variantId), quantity: 1 }], sections: sectionNames },
      };
    }
    return {
      endpoint: '/cart/change.js',
      body: { id: String(options.lineKey), quantity: 0, sections: sectionNames },
    };
  }

  function buildRefreshUrl(rootPath) {
    return String(rootPath || '/').replace(/\/?$/, '/') + '?sections=' + sectionNames;
  }

  function localeEndpoint(rootPath, endpoint) {
    return String(rootPath || '/').replace(/\/$/, '') + endpoint;
  }

  function isNulelaGift(item) {
    return Boolean(item && item.properties && String(item.properties._nulela_gift) === 'true');
  }

  function parseGiftConfig(value) {
    try {
      var parsed = JSON.parse(String(value || ''));
      return parsed && parsed.parents ? parsed : { parents: {} };
    } catch (error) {
      return { parents: {} };
    }
  }

  function uniqueStrings(values) {
    return (values || []).reduce(function (unique, value) {
      var normalised = String(value || '').trim();
      if (normalised && unique.indexOf(normalised) === -1) unique.push(normalised);
      return unique;
    }, []);
  }

  function itemVariantId(item) {
    return String((item && (item.variant_id || item.id)) || '');
  }

  function planNulelaGiftReconciliation(cart, config) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var parents = config && config.parents ? config.parents : {};
    var paidVariantIds = {};
    var seenGifts = {};
    var changes = [];
    var addItems = [];
    var hasUndiscountedGift = false;
    var activeParentVariant = '';
    var activeParentConfig = null;

    items.forEach(function (item) {
      if (!isNulelaGift(item)) paidVariantIds[itemVariantId(item)] = true;
    });

    Object.keys(parents).forEach(function (parentVariant) {
      if (!paidVariantIds[parentVariant]) return;
      var parentConfig = parents[parentVariant];
      if (!activeParentConfig || Number(parentConfig.tier) > Number(activeParentConfig.tier)) {
        activeParentVariant = parentVariant;
        activeParentConfig = parentConfig;
      }
    });

    items.forEach(function (item) {
      if (!isNulelaGift(item)) return;

      var properties = item.properties || {};
      var parentVariant = String(properties._nulela_parent_variant || '');
      var parentConfig = parents[parentVariant];
      var giftVariantId = itemVariantId(item);
      var expectedGiftIds = parentConfig ? uniqueStrings(parentConfig.giftVariantIds) : [];
      var giftToken = parentVariant + ':' + giftVariantId;
      var hasParent = Boolean(parentConfig && paidVariantIds[parentVariant] && parentVariant === activeParentVariant);
      var expectedTier = parentConfig ? String(parentConfig.tier) : '';
      var hasExpectedTier = String(properties._nulela_gift_tier || '') === expectedTier;
      var isExpectedGift = expectedGiftIds.indexOf(giftVariantId) >= 0;

      if (!hasParent || !hasExpectedTier || !isExpectedGift || seenGifts[giftToken]) {
        changes.push({ id: String(item.key), quantity: 0 });
        return;
      }

      seenGifts[giftToken] = true;

      if (Number(item.final_line_price) > 0) {
        hasUndiscountedGift = true;
        changes.push({ id: String(item.key), quantity: 0 });
        return;
      }

      if (Number(item.quantity) !== 1) changes.push({ id: String(item.key), quantity: 1 });
    });

    if (activeParentVariant && activeParentConfig) {
      uniqueStrings(activeParentConfig.giftVariantIds).forEach(function (giftVariantId) {
        if (seenGifts[activeParentVariant + ':' + giftVariantId]) return;
        addItems.push({
          id: giftVariantId,
          quantity: 1,
          properties: {
            _nulela_gift: 'true',
            _nulela_parent_variant: String(activeParentVariant),
            _nulela_gift_tier: String(activeParentConfig.tier),
          },
        });
      });
    }

    return {
      changes: changes,
      addItems: addItems,
      hasUndiscountedGift: hasUndiscountedGift,
      checkoutBlocked: Boolean(changes.length || addItems.length || hasUndiscountedGift),
    };
  }

  function defaultCartRequest(endpoint, body) {
    var options = {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(endpoint, options).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to update free downloads.');
        return payload;
      });
    });
  }

  function reconcileNulelaGifts(cart, options) {
    options = options || {};
    var config = options.config || {};
    var rootPath = options.rootPath || '/';
    var request = options.request || defaultCartRequest;
    var maxPasses = Number(options.maxPasses || 4);

    function runPass(currentCart, passIndex) {
      var plan = planNulelaGiftReconciliation(currentCart, config);
      if (!plan.checkoutBlocked) return Promise.resolve(currentCart);
      if (passIndex >= maxPasses) return Promise.reject(new Error('We could not verify your free PDF downloads. Please try again.'));

      var chain = Promise.resolve();
      plan.changes.forEach(function (change) {
        chain = chain.then(function () {
          return request(localeEndpoint(rootPath, '/cart/change.js'), change);
        });
      });
      if (plan.addItems.length) {
        chain = chain.then(function () {
          return request(localeEndpoint(rootPath, '/cart/add.js'), { items: plan.addItems });
        });
      }

      return chain
        .then(function () { return request(localeEndpoint(rootPath, '/cart.js')); })
        .then(function (nextCart) { return runPass(nextCart, passIndex + 1); });
    }

    return runPass(cart || { items: [] }, 0);
  }

  function replaceSections(sections, shouldOpen) {
    if (!sections || typeof document === 'undefined') return;
    var drawer = document.querySelector('cart-drawer');
    var currentDrawer = document.getElementById('CartDrawer');
    var drawerHtml = sections['cart-drawer'];

    if (drawer && currentDrawer && drawerHtml) {
      var parsedDrawer = new DOMParser().parseFromString(drawerHtml, 'text/html');
      var sourceDrawer = parsedDrawer.querySelector('cart-drawer');
      var sourceContents = parsedDrawer.getElementById('CartDrawer');
      if (sourceContents) {
        currentDrawer.innerHTML = sourceContents.innerHTML;
        drawer.classList.toggle('is-empty', Boolean(sourceDrawer && sourceDrawer.classList.contains('is-empty')));
        var overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
        setTimeout(function () { runGiftReconciliation(false); }, 0);
      }
    }

    var iconHtml = sections['cart-icon-bubble'];
    var currentIcon = document.getElementById('cart-icon-bubble');
    if (currentIcon && iconHtml) {
      var parsedIcon = new DOMParser().parseFromString(iconHtml, 'text/html');
      var sourceIcon = parsedIcon.getElementById('cart-icon-bubble') || parsedIcon.querySelector('.shopify-section');
      if (sourceIcon) currentIcon.innerHTML = sourceIcon.innerHTML;
    }

    if (shouldOpen && drawer && typeof drawer.open === 'function') drawer.open();
  }

  function setStatus(message) {
    var status = document.querySelector('[data-nulela-cart-status]');
    if (status) status.textContent = message || '';
  }

  function setCheckoutBlocked(blocked, message) {
    var checkout = document.getElementById('CartDrawer-Checkout');
    if (checkout) {
      checkout.disabled = Boolean(blocked);
      checkout.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    }
    setStatus(message || '');
  }

  var reconciliationPromise = null;

  function runGiftReconciliation(shouldRefresh) {
    if (typeof document === 'undefined' || reconciliationPromise) return reconciliationPromise || Promise.resolve(null);
    var configElement = document.querySelector('[data-nulela-gift-config]');
    if (!configElement) return Promise.resolve(null);
    var config = parseGiftConfig(configElement.textContent);
    var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var checkout = document.getElementById('CartDrawer-Checkout');
    var reconcilingLabel = checkout && checkout.getAttribute('data-reconciling-label');
    var errorLabel = checkout && checkout.getAttribute('data-reconcile-error');

    setCheckoutBlocked(true, reconcilingLabel);
    reconciliationPromise = defaultCartRequest(localeEndpoint(rootPath, '/cart.js'))
      .then(function (cart) {
        var initialPlan = planNulelaGiftReconciliation(cart, config);
        return reconcileNulelaGifts(cart, { config: config, rootPath: rootPath }).then(function (stableCart) {
          return { cart: stableCart, changed: initialPlan.checkoutBlocked };
        });
      })
      .then(function (result) {
        setCheckoutBlocked(false, '');
        if (result.changed && shouldRefresh !== false) {
          return refreshCart(true).then(function () { return result.cart; });
        }
        return result.cart;
      })
      .catch(function (error) {
        setCheckoutBlocked(true, errorLabel || error.message);
        throw error;
      })
      .finally(function () { reconciliationPromise = null; });

    return reconciliationPromise;
  }

  function refreshCart(shouldOpen) {
    var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return fetch(buildRefreshUrl(rootPath), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh the cart.');
        return response.json();
      })
      .then(function (sections) { replaceSections(sections, shouldOpen); })
      .catch(function (error) { setStatus(error.message); });
  }

  function updateProtection(toggle) {
    var request = buildProtectionRequest({
      enabled: toggle.checked,
      variantId: toggle.getAttribute('data-variant-id'),
      lineKey: toggle.getAttribute('data-line-key'),
    });
    var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    toggle.disabled = true;
    setStatus(toggle.getAttribute('data-loading-label'));

    return fetch(localeEndpoint(rootPath, request.endpoint), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(request.body),
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to update shipping protection.');
          return payload;
        });
      })
      .then(function (payload) {
        replaceSections(payload.sections, true);
        setStatus('');
      })
      .catch(function (error) {
        toggle.checked = !toggle.checked;
        toggle.disabled = false;
        setStatus(error.message);
      });
  }

  function init() {
    if (document.documentElement.getAttribute('data-nulela-cart-initialized') === 'true') return;
    document.documentElement.setAttribute('data-nulela-cart-initialized', 'true');
    tickReminder();
    window.setInterval(tickReminder, 1000);
    document.addEventListener('change', function (event) {
      var toggle = event.target.closest('[data-nulela-protection-toggle]');
      if (toggle) updateProtection(toggle);
      if (event.target.closest('.nulela-cart-drawer .quantity__input')) {
        setTimeout(function () { runGiftReconciliation(true); }, 900);
      }
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest('.nulela-cart-drawer cart-remove-button, .nulela-cart-drawer .quantity__button')) {
        setTimeout(function () { runGiftReconciliation(true); }, 900);
      }
    });
    document.addEventListener('cart-drawer:refresh', function () {
      refreshCart(true).then(function () { return runGiftReconciliation(true); });
    });
    runGiftReconciliation(false).catch(function () {});
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }

  return {
    reminderDeadline: reminderDeadline,
    reminderTime: reminderTime,
    buildProtectionRequest: buildProtectionRequest,
    buildRefreshUrl: buildRefreshUrl,
    localeEndpoint: localeEndpoint,
    isNulelaGift: isNulelaGift,
    parseGiftConfig: parseGiftConfig,
    planNulelaGiftReconciliation: planNulelaGiftReconciliation,
    reconcileNulelaGifts: reconcileNulelaGifts,
    runGiftReconciliation: runGiftReconciliation,
    replaceSections: replaceSections,
    refreshCart: refreshCart,
    updateProtection: updateProtection,
  };
});
